import type { ColorPalette, IconProps } from '@workramp/ui';

const { APP_CONSTANTS } = window;
const { CMS_ASSET_TYPES } = APP_CONSTANTS;

interface IconPropsSearchResultProps {
  type: string;
  subType?: string;
  colors: ColorPalette;
}

export const getIconPropsSearchResult = ({ type, subType, colors }: IconPropsSearchResultProps): IconProps => {
  const { red, orange, green, blue, teal, purple, neutral } = colors.decorative;

  switch (type) {
    case 'guide':
    case 'guide_task':
    case 'guide_section':
      return { name: 'guide:regular', color: blue[500] };
    case 'scorm':
      return { name: 'scorm:regular', color: orange[500] };
    case 'resource':
      return { name: 'resource:regular', color: teal[500] };
    case 'challenge':
      return { name: 'challenge:regular', color: orange[500] };
    case 'path':
      return { name: 'path:regular', color: green[500] };
    case 'library':
      return { name: 'library:regular', color: purple[500] };
    case 'cms_file':
    case CMS_ASSET_TYPES.FILE:
      return { name: 'file-document:regular', color: neutral[900] };
    case CMS_ASSET_TYPES.LINK:
    case 'cms_link':
      return { name: 'link:regular', color: neutral[900] };
    case 'section':
      return { name: 'guide:regular', color: blue[500] };
    case 'total_views':
      return { name: 'eye-open:regular', color: blue[900] };
    case 'downloads_action':
    case 'total_downloads_file':
      return { name: 'download:regular', color: blue[900] };
    case 'total_downloads_link':
      return { name: 'copy:regular', color: blue[900] };
    case 'event':
      return { name: 'event:regular', color: red[500] };
    case APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.LINKEDIN_LEARNING:
      return { name: 'linkedin:brand', color: null };
    case APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.UDEMY:
      return { name: 'udemy:brand', color: null };
    case APP_CONSTANTS.CONTENT_PROVIDER_TOP_LEVEL_CONTENT_TYPE:
      if (subType === APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.LINKEDIN_LEARNING) {
        return { name: 'linkedin:brand', color: null };
      }
      if (subType === APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.UDEMY) {
        return { name: 'udemy:brand', color: null };
      }
      return { name: 'null:regular', color: neutral[900] };
    default:
      return { name: 'null:regular', color: neutral[900] };
  }
};
